// frontend/src/components/auth/Login.jsx
import React, { useState } from 'react';

const API = process.env.REACT_APP_API_URL || 'https://api.lamilara.com/api';

export default function Login({ onLogin }) {
  const [form,     setForm]     = useState({ usuario:'', clave:'' });
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError(null);
    try {
      const res  = await fetch(`${API}/auth/login`, {
        method:  'POST',
        headers: { 'Content-Type':'application/json' },
        body:    JSON.stringify(form),
      });
      const data = await res.json();
      if (!data.ok) throw new Error(data.mensaje);
      localStorage.setItem('calleb_token',   data.token);
      localStorage.setItem('calleb_usuario', JSON.stringify(data.usuario));
      onLogin(data.usuario, data.token);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight:'100vh', background:'linear-gradient(135deg,#1a3a5c 0%,#0f2140 100%)',
      display:'flex', alignItems:'center', justifyContent:'center', padding:16,
    }}>
      <div style={{
        background:'#fff', borderRadius:20, padding:'40px 36px',
        width:'100%', maxWidth:400, boxShadow:'0 24px 64px rgba(0,0,0,.3)',
      }}>
        {/* Logo */}
        <div style={{ textAlign:'center', marginBottom:32 }}>
          <div style={{ fontSize:48 }}>🏠</div>
          <h1 style={{ fontSize:22, fontWeight:800, color:'#1a3a5c', margin:'8px 0 4px' }}>
            Calle B
          </h1>
          <p style={{ fontSize:13, color:'#9ca3af', margin:0 }}>
            Sistema de Administración de Condominio
          </p>
        </div>

        {error && (
          <div style={{ background:'#fef2f2', color:'#dc2626', padding:'12px 16px',
                        borderRadius:10, fontSize:13, marginBottom:20, textAlign:'center' }}>
            ⚠️ {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom:16 }}>
            <label style={labelStyle}>Usuario</label>
            <input
              type="text" value={form.usuario} required autoFocus
              onChange={e => setForm(f => ({ ...f, usuario: e.target.value }))}
              style={inputStyle} placeholder="Ingresa tu usuario"
            />
          </div>
          <div style={{ marginBottom:24 }}>
            <label style={labelStyle}>Contraseña</label>
            <input
              type="password" value={form.clave} required
              onChange={e => setForm(f => ({ ...f, clave: e.target.value }))}
              style={inputStyle} placeholder="••••••••"
            />
          </div>
          <button type="submit" disabled={loading} style={{
            width:'100%', padding:'14px',
            background: loading ? '#9ca3af' : '#1a3a5c',
            color:'#fff', border:'none', borderRadius:10,
            fontSize:15, fontWeight:700, cursor: loading ? 'default' : 'pointer',
            transition:'background .2s',
          }}>
            {loading ? 'Verificando…' : 'Iniciar Sesión'}
          </button>
        </form>

        <p style={{ textAlign:'center', fontSize:11, color:'#d1d5db', marginTop:24 }}>
          Condominio Calle B © {new Date().getFullYear()}
        </p>
      </div>
    </div>
  );
}

const labelStyle = {
  display:'block', fontSize:12, fontWeight:600,
  color:'#374151', marginBottom:6,
};
const inputStyle = {
  width:'100%', padding:'12px 14px', borderRadius:10,
  border:'1px solid #d1d5db', fontSize:14,
  background:'#f9fafb', color:'#111827', boxSizing:'border-box',
  outline:'none',
};
